import styled from "@emotion/styled";

const SectionTitle = styled("h2")(() => ({
  fontSize: 100,
  fontWeight: "bold",
  fontFamily: "Oswald",
  lineHeight: 1,
  "@media (max-width: 768px)": {
    textAlign: "center",
    fontSize: 80,
  },
  "@media (min-width: 768px)": {
    textAlign: "left",
  },
}));

export default SectionTitle;
